import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EmptyState from "../../shared/components/table/empty-state";
const NoTemplates = () => (_jsx(EmptyState, { type: "templates", isTable: false, fullHeight: true }));
export default NoTemplates;
